type TypeActionNameWithTo = {
  name: string
  to: string
  icon: string
}

type PortletTitleCrudType = {
  create: TypeActionNameWithTo
  read: TypeActionNameWithTo
  update: TypeActionNameWithTo
  delete: TypeActionNameWithTo
}

const nameEntity = 'Promoter'
const nameSource = 'partnerships/promoters'
const namePageTitle = 'Promotores'

const nameActionPageMain: TypeActionNameWithTo = {
  name: 'Promotores',
  to: '/partnerships/promoters',
  icon: ''
}

const nameActions: PortletTitleCrudType = {
  create: {
    name: 'Adicionar',
    to: '/partnerships/promoters/create/',
    icon: 'fa fa-plus'
  },
  read: {
    name: 'Visualizar',
    to: '/partnerships/promoters/',
    icon: 'fa fa-list'
  },
  update: {
    name: 'Editar',
    to: '/partnerships/promoters/update/',
    icon: 'fa fa-edit'
  },
  delete: {
    name: 'Remover',
    to: '#!',
    icon: 'fa fa-remove'
  }
}

export enum PROMOTER_USER_ROLE_ENUM {
  MASTER = 'MASTER'
}

export const PROMOTER_USER_ROLE_MAP: Record<PROMOTER_USER_ROLE_ENUM, string> = {
  MASTER: 'MASTER'
}

export {
  nameEntity,
  nameSource,
  namePageTitle,
  nameActionPageMain,
  nameActions
}
